export class SecondaryVehicleType {
  id: number = -1;

  vehicleTypeId: number = -1;
  name: string = '';

  createdAt: string = '';
  updatedAt: string = '';
}
